import React from 'react'
import { AWARDS_AND_RECOGNITION } from '../../data/data'

const AwardsAndRecognition = () => {
  return (
    <article className="min-h-[calc(100vh-200px)] flex flex-col items-center p-4 md:py-16 bg-gray-50 dark:bg-[#0F172A]">
      <section className="container mx-auto">
        {/* Section Header */}
        <div className="text-left md:text-center mb-12">
          <h6 className="text-blue-600 text-base font-medium uppercase mb-2">
            Awards & Recognition
          </h6>
          <h3 className="mb-4 md:text-2xl text-xl font-semibold dark:text-white">
            Our Achievements
          </h3>
          <p className="text-slate-500 dark:text-slate-300 max-w-xl mx-auto">
            Recognition from our peers and industry experts for the work we do.
          </p>
        </div>

        {/* Awards Grid */}
        <section className="grid grid-cols-1 md:grid-cols-3 gap-8 justify-items-center">
          {AWARDS_AND_RECOGNITION?.map((award) => (
            <div
              key={award.id}
              className="group bg-white dark:bg-[#0F172A] rounded-xl shadow-lg dark:shadow-gray-800 overflow-hidden max-w-[350px] w-full transition-transform duration-300 hover:shadow-2xl"
            >
              {/* Image fills top */}
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  src={award.imageSrc}
                  alt={award.heading}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                />
              </div>

              {/* Text overlay with effect */}
              <div className="p-6 text-center">
                <h4 className="text-lg font-semibold text-slate-800 dark:text-white mb-2
                   duration-500 translate-y-0 group-hover:text-green-600">
                  {award.heading}
                </h4>
                <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed
                  transition-all duration-500 opacity-100">
                  {award.description}
                </p>
              </div>
            </div>
          ))}
        </section>
      </section>
    </article>
  )
}

export default AwardsAndRecognition
